import { Input, Pagination } from '@enterprise-ui/canvas-ui-react'

export const TablePagination = ({
  className,
  dataTestId,
  currentPage,
  totalRecords,
  recordsPerPage,
  onRequestNext,
  onRequestPrev,
  onRequestFirst,
  onRequestLast,
  onRequestPage,
  onRequestRecordsPerPage,
  recordsPerPageOptions,
  hide,
}) => {
  const startingRange = (currentPage - 1) * recordsPerPage + 1
  const endingRange = Math.min(currentPage * recordsPerPage, totalRecords)
  const showingRecordsString = `Showing ${startingRange} - ${endingRange} of ${totalRecords} records`

  return (
    <>
      {currentPage &&
      totalRecords &&
      recordsPerPage &&
      onRequestNext &&
      onRequestPrev &&
      onRequestFirst &&
      onRequestLast &&
      onRequestPage &&
      onRequestRecordsPerPage &&
      recordsPerPageOptions &&
      !hide ? (
        <div
          className={`hesp-general-flex hesp-general-alignItemsCenter ${className}`}
        >
          <span className="hesp-general-flex-grow hesp-general-fullwidth">
            {showingRecordsString}
          </span>
          <Pagination
            className="hesp-general-flex-grow hesp-general-justifyCenter hesp-general-fullwidth"
            data-testid={dataTestId}
            currentPage={currentPage}
            onRequestNext={onRequestNext}
            onRequestPrev={onRequestPrev}
            onRequestFirst={onRequestFirst}
            onRequestLast={onRequestLast}
            onRequestPage={(event, value) => onRequestPage(value)}
            pageSelector
            totalPages={Math.ceil(totalRecords / recordsPerPage)}
          />
          <span className="hesp-general-flex hesp-general-alignItemsCenter hesp-general-justifyEnd hesp-general-flex-grow hesp-general-fullwidth">
            <span className="hc-mr-xs">Records per page</span>
            <Input.Select
              data-testid={dataTestId ? `${dataTestId}_pageSizeSelect` : null}
              size="dense"
              value={recordsPerPage}
              onUpdate={(id, value) => {
                onRequestRecordsPerPage(value)
              }}
              options={recordsPerPageOptions.map((option) => {
                return {
                  label: option,
                  value: option,
                }
              })}
            />
          </span>
        </div>
      ) : null}
    </>
  )
}
